import React, { useEffect, useState } from "react";
import { Mixpanel } from "lib/mixpanel/mixpanel";

import Markdown from "components/markdown/markdown";
import { MIXPANEL_TOKEN } from "lib/constants";
import { useUserData } from "lib/store/user";

const TrackedLink = ({
  href,
  component,
  children,
}: {
  href: string;
  component: string;
  children: React.ReactNode;
}) => {
  const { userId } = useUserData();
  const [mixpanel, setMixpanel] = useState<Mixpanel | null>(null);

  useEffect(() => {
    setMixpanel(new Mixpanel(MIXPANEL_TOKEN));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const track = () => {
    if (userId && mixpanel) {
      mixpanel.track("Link Click", {
        Component: component,
        "Link Clicked": href,
        distinct_id: userId,
      });
    }
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-cerise"
      onClick={() => track()}
    >
      {children}
    </a>
  );
};

export const MarkdownTracked = ({
  text,
  component,
  className,
}: {
  text: string;
  component: string;
  className?: string;
}) => {
  return (
    <Markdown
      className={className}
      options={{
        forceBlock: true,
        overrides: {
          a: {
            component: TrackedLink,
            props: {
              component,
            },
          },
        },
      }}
      text={text}
    />
  );
};
